module.exports = __webpack_public_path__ + "img/logo-cn.bb05e05d.png";